import React from 'react';
import { stringToColor } from '../components/utils'; 
import defaultAvatar from '../images/default-avatar.png';

const userProfileImage = ({ initials, photo, id }) => {
    if (!initials && !photo) return <img src={defaultAvatar} className="user_photo" alt="user_photo" />

    return photo ? <div style={{ backgroundImage: `url(${photo})` }} className="user_photo" alt="user_photo" /> :
     <div className="profile" style={{ backgroundColor: stringToColor(initials + id) }}>{initials}</div>
};
export default userProfileImage;

//export const getInitials = (profile) => { return `${(profile && profile.FirstName) ? profile.FirstName.substr(0, 1) : ""}${(profile && profile.LastName) ? profile.LastName.substr(0, 1) : ""}`;}
export const getInitials = (profile) => { return `${(profile && profile.FirstName) ? profile.FirstName.substr(0, 1) : ""}`;}